package com.evoapps.evoshift.widgets

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.CloudDone
import androidx.compose.material.icons.filled.CloudOff
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.semantics.LiveRegionMode
import androidx.compose.ui.semantics.liveRegion
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.connectivity.ConnectionNotice
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.LightGold
import com.evoapps.evoshift.ui.theme.MotionVisibility
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.connectivity_back_online
import evoshift.composeapp.generated.resources.connectivity_offline
import org.jetbrains.compose.resources.stringResource

/** Test tag of [ConnectivityBanner], for robots. */
const val CONNECTIVITY_BANNER_TAG = "connectivity_banner"

/**
 * SH-168: the shell's line about the connection: "No connection. Changes are kept on this
 * device." while there is none (Firestore keeps the writes until then; SH-186), "Back online" for
 * a moment after it returns, nothing otherwise. It unfolds and folds away.
 */
@Composable
fun ConnectivityBanner(notice: ConnectionNotice, modifier: Modifier = Modifier) {
    // The last notice shown, so the banner keeps its text while it folds away.
    val last = remember { arrayOf(ConnectionNotice.OFFLINE) }
    if (notice != ConnectionNotice.NONE) last[0] = notice
    val shown = last[0]
    MotionVisibility(notice != ConnectionNotice.NONE, modifier) {
        val offline = shown == ConnectionNotice.OFFLINE
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .background(if (offline) DeepNavy else Color(0xFF2E7D32))
                .testTag(CONNECTIVITY_BANNER_TAG)
                .semantics(mergeDescendants = true) { liveRegion = LiveRegionMode.Polite }
                .padding(horizontal = 16.dp, vertical = 8.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(12.dp)
        ) {
            Icon(
                if (offline) Icons.Default.CloudOff else Icons.Default.CloudDone,
                contentDescription = null,
                tint = if (offline) LightGold else Color.White,
                modifier = Modifier.size(20.dp)
            )
            Text(
                stringResource(if (offline) Res.string.connectivity_offline else Res.string.connectivity_back_online),
                color = Color.White.copy(alpha = 0.95f),
                style = MaterialTheme.typography.bodySmall
            )
        }
    }
}
